import angular from 'angular';
import './globals';
import '../resources/tags-groups';
import { cloneDeep } from 'lodash';

const module = angular.module('whyline.services.tags-groups', ['whyline.resources.tags-groups']);

let TagsGroups;

class TagsGroupsService {
  static $inject = ['TagsGroups'];

  constructor(injectedTagsGroups) {
    /*@ngInject*/
    TagsGroups = injectedTagsGroups;
  }

  GetAll() {
    return TagsGroups.FetchAll();
  }

  GetAllAsPromise() {
    return TagsGroups.FetchAll({
      promise: true,
    });
  }

  GetAllAsPromiseFromServer() {
    return TagsGroups.FetchAll({
      promise: true,
      force: true,
    });
  }

  GetOneAsPromiseFromServer(tagGroupId) {
    return TagsGroups.FindById(tagGroupId, {
      promise: true,
      force: true,
    });
  }

  Copy(tagGroup) {
    const copy = cloneDeep(tagGroup);
    return new TagsGroups(copy);
  }

  Create(data) {
    const newTagGroup = new TagsGroups(data);
    return TagsGroups.Save(newTagGroup);
  }

  Update(data) {
    return TagsGroups.Save(data);
  }

  Enable(tagGroup) {
    return new TagsGroups(tagGroup).enable(!tagGroup.enabled);
  }

  UpdateTags(groupId, tags) {
		return TagsGroups.UpdateTags(groupId, tags);
	}
}

module.exports = module.service('TagsGroupsService', TagsGroupsService);
